import { useState } from "react";
import { useTranslation } from "react-i18next";

const FAQ_DATA_AZ = [
  {
    q: "Mail.net.az xidmətindən kimler istifadə edə bilər?",
    a: "Mail.net.az xidmətindən yalnız Azərbaycan Respublikasının vətəndaşları istifadə edə bilər. Qeydiyyat zamanı şəxsiyyət vəsiqəsi seriya/nömrəsi və FİN nömrəsi tələb olunur.",
  },
  {
    q: "FİN nömrəsi nədir və harda tapa bilərəm?",
    a: "FİN (Fərdi İdentifikasiya Nömrəsi) — Azərbaycan vətəndaşlarına verilən 7 rəqəmli unikal nömrədir. Bu nömrəni yeni nəsil şəxsiyyət vəsiqənizin ön üzündə tapa bilərsiniz.",
  },
  {
    q: "Email ünvanım @mail.net.az formatında olacaqmı?",
    a: "Bəli. Qeydiyyat zamanı ad.soyad@mail.net.az formatında email ünvanı seçirsiniz. Bu ünvan yalnız mail.net.az daxilindən istifadə olunur.",
  },
  {
    q: "Hesabımı silsəm məlumatlarım nə olacaq?",
    a: "Hesab silindikdən sonra bütün məlumatlarınız 30 gün ərzində tamamilə sistemdən silinir. Bu müddət ərzində hesabınızı bərpa etmək mümkündür.",
  },
  {
    q: "Şifrəmi unutsam nə etməliyəm?",
    a: "Daxil ol səhifəsindəki 'Şifrəni unutmusunuz?' linkinə klikləyin. FİN nömrəniz vasitəsilə kimliğinizi doğrulayaraq yeni şifrə yarada bilərsiniz.",
  },
  {
    q: "Email-lər şifrələnirmi?",
    a: "Bəli. Bütün email məktubları AES-256 standartı ilə şifrələnir. Məlumatlarınız serverlərimizdə təhlükəsiz saxlanılır.",
  },
];

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-red-600 text-xs font-bold tracking-widest uppercase">FAQ</span>
          <h2 className="text-3xl font-extrabold text-gray-900 mt-2">{t("support.faq_title")}</h2>
          <p className="text-gray-500 text-sm mt-2">{t("support.faq_subtitle")}</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {FAQ_DATA_AZ.map((item, i) => (
            <div key={i} className="bg-white rounded-xl overflow-hidden">
              <button
                className="w-full text-left px-6 py-4 flex items-center justify-between gap-4 cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-medium text-gray-900 text-sm">{item.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`text-gray-400 transition-transform ${openIndex === i ? "ri-subtract-line" : "ri-add-line"}`} />
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-500 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
